<div
  class="malfunction-card__timeline"
  [class.malfunction-card__timeline--future]="this.isFutureMessage()"
  [class.malfunction-card__timeline--no-line]="this.isMajorDisruption() || this.isActiveTicket()"
>
  <div class="malfunction-card__timeline-item">
    @if (showTimeElement()) {
      <div class="malfunction-card__timeline-date">
        {{ startTimestamp() | date: "d MMM y" : "" : localeIdentifier() }}
      </div>
    }
    <div
      [class.malfunction-card__embedded]="isEmbedded()"
      class="malfunction-card"
      [class.malfunction-card__major-disruption]="isMajorDisruption()"
    >
      <div class="malfunction-card__inner">
        <header class="malfunction-card__header">
          @if (isMalfunction()) {
            <div class="malfunction-card__icon-box malfunction-card__icon-box--malfunction">
              <svg-icon src="assets/images/icons/status-malfunction.svg"> </svg-icon>
            </div>
          }
          @if (isPlannedWork() && !isFutureMessage()) {
            <div class="malfunction-card__icon-box malfunction-card__icon-box--maintenance">
              <svg-icon src="assets/images/icons/status-maintenance.svg"> </svg-icon>
            </div>
          }
          @if (isPlannedWork() && isFutureMessage()) {
            <div class="malfunction-card__icon-box malfunction-card__icon-box--maintenance-planned">
              <svg-icon src="assets/images/icons/status-maintenance-planned.svg"> </svg-icon>
            </div>
          }
          <div class="malfunction-card__header-caption">
            <h3 class="malfunction-card__title">{{ title() }}</h3>
            <div>
              {{ "Malfunction.RegisteredOn" | translate }}:
              {{ planTimestamp() | date: "d MMM y, HH:mm" : "" : localeIdentifier() }}
            </div>
          </div>
          <div class="malfunction-card__calendar-button" (click)="addToCalendar()">
            <svg-icon src="assets/images/icons/icon-add-to-calendar.svg"> </svg-icon>
            <span>{{ "Malfunction.AddToCalendar" | translate }}</span>
          </div>
        </header>
        <div class="malfunction-card__body">
          <p>{{ description() }}</p>
          <ul class="malfunction-card__update-list">
            @for (update of updates(); track update.description) {
              <li class="malfunction-card__update-item">
                <div class="malfunction-card__update-time">
                  {{ update.timestamp | date: "d MMM y, HH:mm" : "" : localeIdentifier() }}
                </div>
                <div class="malfunction-card__update-description">
                  {{ update.description }}
                </div>
              </li>
            }
          </ul>
        </div>
      </div>
      <div class="malfunction-card__bottom">
        <div class="malfunction-card__bottom-col">
          <div class="malfunction-card__bottom-box">
            <div class="malfunction-card__bottom-title">{{ "Malfunction.StartMalfunction" | translate }}</div>
            <div>{{ startTimestamp() | date: "d MMM y, HH:mm" : "" : localeIdentifier() }}</div>
          </div>
        </div>
        <div class="malfunction-card__bottom-col">
          <div class="malfunction-card__bottom-box">
            <div class="malfunction-card__bottom-title">{{ "Malfunction.EndMalfunction" | translate }}</div>
            <div>{{ endTimestamp() | date: "d MMM y, HH:mm" : "" : localeIdentifier() }}</div>
          </div>
        </div>
        <div class="malfunction-card__bottom-col">
          <div class="malfunction-card__bottom-box">
            <div class="malfunction-card__bottom-title">{{ "Malfunction.Impact" | translate }}</div>
            <div>
              @if (!isMajorDisruption()) {
                {{ impactsString() | cim_impact_type }}
              } @else {
                P1
              }
            </div>
          </div>
        </div>
        <div class="malfunction-card__bottom-col">
          <div
            class="malfunction-card__bottom-box malfunction-card__bottom-box--clickable"
            (click)="toggleAffectedSubscriptions()"
            data-testid="services-affected-by-malfunction"
            title="{{ 'Malfunction.AffectedServices.Title' | translate }}"
          >
            <div class="malfunction-card__bottom-title">{{ "Malfunction.AffectedServices" | translate }}</div>
            <div class="malfunction-card__bottom-link" style="text-transform: lowercase">
              @if (isMajorDisruption()) {
                {{ "Malfunction.AffectedServices.Allservices" | translate }}
              } @else {
                {{ nrOfAffectedServices() }} {{ "Malfunction.AffectedServices" | translate }}
              }
            </div>
          </div>
        </div>
      </div>
      <div
        class="malfunction-card__affected-list"
        [class.revealed]="showAffectedSubscriptions()"
        [class.hidden]="!showAffectedSubscriptions()"
      >
        @for (affectedSubscription of affectedSubscriptions(); track affectedSubscription.subscriptionId) {
          <affected-service
            [service]="affectedSubscription.subscription"
            [impact]="affectedSubscription.impactType"
          ></affected-service>
        }
      </div>
    </div>
  </div>
</div>
